import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MyMemberships from "../components/MyMemberships";

const membershipOptions = [
  {
    type: "Family Membership",
    amount: "$40",
    description: "2 adults and children under 18 in the same household.",
  },
  {
    type: "Single Adult Membership",
    amount: "$30",
    description: "For one adult account applicant.",
  },
  {
    type: "Student Membership",
    amount: "$20",
    description: "For one full-time student with valid student ID.",
  },
  {
    type: "Senior Couple Membership",
    amount: "$25",
    description: "For two seniors aged 65+.",
  },
  {
    type: "Family One Adult",
    amount: "$25",
    description: "One adult with children under 18.",
  },
  {
    type: "Senior Single Membership",
    amount: "$15",
    description: "For one senior aged 65+.",
  },
];

export default function MembershipDashboard() {
  const navigate = useNavigate();
  const [member, setMember] = useState(null);

  useEffect(() => {
    const savedMember = localStorage.getItem("member");

    if (!savedMember) {
      navigate("/login");
      return;
    }

    const parsedMember = JSON.parse(savedMember);
    setMember(parsedMember);
  }, [navigate]);

  const handleNewMembership = (membershipType) => {
    navigate("/membershipform", {
      state: { membershipType },
    });
  };

  const handleLogout = () => {
    localStorage.removeItem("member");
    navigate("/login");
  };

  return (
    <section className="min-h-screen bg-gray-50 px-4 py-10">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-2xl shadow-md p-6 mb-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold text-brand">
              Membership Dashboard
            </h1>
            <p className="text-gray-600 mt-2">
              Welcome{member?.full_name ? `, ${member.full_name}` : ""}. Manage
              memberships for yourself and your family.
            </p>
          </div>

          <button
            onClick={handleLogout}
            className="px-5 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-white font-medium transition"
          >
            Logout
          </button>
        </div>

        <div className="bg-white rounded-2xl shadow-md p-6 mb-8">
          <h2 className="text-2xl font-bold text-brand mb-2">
            Start a New Membership
          </h2>
          <p className="text-gray-600 mb-6">
            Choose a membership type to create a new application.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
            {membershipOptions.map((item) => (
              <div
                key={item.type}
                className="border border-gray-200 rounded-2xl p-5 bg-white shadow-sm hover:shadow-lg transition"
              >
                <div className="h-2 w-full rounded-full bg-yellow-500 mb-4" />
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {item.type}
                </h3>
                <p className="text-gray-600 text-sm mb-4">{item.description}</p>

                <div className="flex items-center justify-between">
                  <span className="inline-block px-4 py-1 rounded-full bg-green-100 text-green-700 font-bold">
                    {item.amount}
                  </span>

                  <button
                    onClick={() => handleNewMembership(item.type)}
                    className="px-4 py-2 rounded-lg bg-brand text-white font-medium hover:opacity-90 transition"
                  >
                    Apply
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <MyMemberships />
      </div>
    </section>
  );
}